import React from "react";
import { FaDownload } from "react-icons/fa";
import { json } from "react-router-dom";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

const CustomCategExcelConvetor = ({
  jsonData,
  excelFileName,
  excelTitle,
  selectedGroupId,
}) => {
  const convertJsonToExcel = () => {
    let details = jsonData[0]?.groupMaster;
    const formatDate = (dateString) => {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      return new Date(dateString).toLocaleDateString("en-US", options);
    };

    const modifiedData = jsonData?.map((item) => ({
      "Need Name": jsonData?.Need_Name,
      Type: item?.type,
    }));

    const ws = XLSX.utils.json_to_sheet(jsonData, { origin: "A9" });
    console.log("Json dat ---> ", details);
    // Set title
    ws["C1"] = { t: "s", v: excelTitle };

    ws["A3"] = { t: "s", v: "Group Id :" };
    ws["B3"] = { t: "s", v: details?.id };

    ws["C3"] = { t: "s", v: "Group Name :" };
    ws["D3"] = { t: "s", v: `${details?.name}` };

    ws["A4"] = { t: "s", v: "Group Creation Date Time :" };
    ws["B4"] = { t: "s", v: formatDate(details?.created_at) };

    ws["A5"] = { t: "s", v: "Group Description :" };
    ws["B5"] = { t: "s", v: details?.description };

    ws["C7"] = { t: "s", v: "Custom Categories" };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, excelFileName, { compression: true });
  };

  const handleDownloadClick = () => {
    if (selectedGroupId !== null) {
      convertJsonToExcel();
    } else {
      toast.error("Please select a group");
    }
  };

  return (
    <div>
      <button
        data-toggle="tooltip"
        data-placement="top"
        title="Download List"
        className="text-white flex ml-4 mt-2 bg-orange-500 hover:text-black font-medium rounded text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none dark:focus:ring-blue-800"
        onClick={handleDownloadClick}
      >
        <FaDownload className="text-base mr-1" /> Download
      </button>
    </div>
  );
};

export default CustomCategExcelConvetor;
